import * as Icons from "@nova/component-icons"
import { useAppSelector } from "integrations/redux/hooks"
import { selectWorkspaceMembers } from "features/entity-caching/members/UserManagementSlice"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"

const MAX_FACES = 3

export const ReplyThreadButton = ({
    numReplies,
    participantIds,
}: {
    numReplies: number
    participantIds: string[]
}) => {
    const members = useAppSelector(selectWorkspaceMembers)
    const faces = participantIds.slice(0, MAX_FACES)
    const overflow = participantIds.length - faces.length

    return (
        <div className="group/thread flex items-center gap-2 pl-[5px] pr-2 py-1 rounded-lg border border-transparent group-hover/comment:bg-gray-700 group-hover/comment:border-white-200">
            <div className="flex items-center gap-1 shrink-0">
                {faces.map((userId) => (
                    <div
                        key={userId}
                        className="w-6 min-w-[24px] aspect-square rounded-lg overflow-hidden"
                    >
                        <ProfilePhoto
                            userId={userId}
                            fullName={
                                members.find((member) => member.userId === userId)?.fullName ?? ""
                            }
                        />
                    </div>
                ))}
                {overflow > 0 && (
                    <div className="w-6 min-w-[24px] aspect-square rounded-lg bg-gray-800 flex items-center justify-center select-none">
                        <small className="text-white-700">{`+${overflow}`}</small>
                    </div>
                )}
            </div>
            <small className="grid grow min-w-0 text-gray-300 group-hover/comment:text-gray-50">
                <span className="col-start-1 row-start-1 truncate transition-opacity duration-[80ms] ease-out group-hover/comment:opacity-0">
                    {numReplies} {numReplies === 1 ? "Reply" : "Replies"}
                </span>
                <span className="col-start-1 row-start-1 truncate opacity-0 transition-opacity duration-[80ms] ease-out group-hover/comment:opacity-100">
                    View Thread
                </span>
            </small>
            <Icons.SmallIcon
                Icon={Icons.ArrowRight}
                className="shrink-0 opacity-0 transition-opacity duration-[80ms] ease-out group-hover/comment:opacity-100 text-gray-50"
            />
        </div>
    )
}
